(ns ui.components.calculi-tree.predefined-expressions)

(def A {:calculi-type :calculi-type/field :field :A})
(def B {:calculi-type :calculi-type/field :field :B})
(def C {:calculi-type :calculi-type/field :field :C})

(def expressions
  {"A / B"
   {:calculi-type :calculi-type/operator-division
    :rules [A B]}

   "A + B"
   {:calculi-type :calculi-type/operator-sum
    :rules [A B]}

   "A - B"
   {:calculi-type :calculi-type/operator-subtraction
    :rules [A B]}

   "A * B"
   {:calculi-type :calculi-type/operator-multiplication
    :rules [A B]}

   "(A + B) / C"
   {:calculi-type :calculi-type/operator-division
    :rules [
            {:calculi-type :calculi-type/operator-sum
             :rules [A B]}
            C]}

   "(A + B) * C"
   {:calculi-type :calculi-type/operator-multiplication
    :rules [
            {:calculi-type :calculi-type/operator-sum
             :rules [A B]}
            C]}

   "A + B + C"
   {:calculi-type :calculi-type/operator-sum
    :rules [A B C]}

   "A - B - C"
   {:calculi-type :calculi-type/operator-subtraction
    :rules [
            {:calculi-type :calculi-type/operator-subtraction
             :rules [A B]}
            C]}

   "A + B - C"
   {:calculi-type :calculi-type/operator-subtraction
    :rules [
            {:calculi-type :calculi-type/operator-sum
             :rules [A B]}
            C]}

   "(A * B) / C"
   {:calculi-type :calculi-type/operator-division
    :rules [
            {:calculi-type :calculi-type/operator-multiplication
             :rules [A B]}
            C]}

   "(A / B) * C"
   {:calculi-type :calculi-type/operator-multiplication
    :rules [
            {:calculi-type :calculi-type/operator-division
             :rules [A B]}
            C]}

   "(A / B) - C"
   {:calculi-type :calculi-type/operator-subtraction
    :rules [
            {:calculi-type :calculi-type/operator-division
             :rules [A B]}
            C]}

   "(A - B) / C"
   {:calculi-type :calculi-type/operator-division
    :rules [
            {:calculi-type :calculi-type/operator-subtraction
             :rules [A B]}
            C]}

   "A / (B + C)"
   {:calculi-type :calculi-type/operator-division
    :rules [
            A
            {:calculi-type :calculi-type/operator-sum
             :rules [B C]}]}

   "A / (B - C)"
   {:calculi-type :calculi-type/operator-division
    :rules [
            A
            {:calculi-type :calculi-type/operator-subtraction
             :rules [B C]}]}

   "A / (B * C)"
   {:calculi-type :calculi-type/operator-division
    :rules [
            A
            {:calculi-type :calculi-type/operator-multiplication
             :rules [B C]}]}

   "A + 100"
   {:calculi-type :calculi-type/operator-sum
    :rules [{:calculi-type :calculi-type/field :field :A}
            {:calculi-type :calculi-type/constant :value 100}]}
   })

(defn replace-symbols
  [node sym->field]
  (let [type (:calculi-type node)]
    (cond
      ;; Replace symbolic fields
      (= type :calculi-type/field)
      (let [sym (:field node)]
        (if-let [replacement (sym->field sym)]
          (assoc node :field replacement)
          ;; Support field already being a proper value
          (if (keyword? sym)
            node
            (throw (ex-info "Unknown symbolic field" {:symbol sym :node node})))))

      ;; Pass through constants
      (= type :calculi-type/constant)
      node

      ;; Recurse on rule-based structures
      (contains? #{:calculi-type/operator-sum
                   :calculi-type/operator-subtraction
                   :calculi-type/operator-multiplication
                   :calculi-type/operator-division
                   :calculi-type/parenthesis-group} type)
      (update node :rules #(mapv (fn [child] (replace-symbols child sym->field)) %))

      :else node)))


(defn expression->template
  [expression field-options]
  (let [template (get expressions expression)
        symbols (map #(keyword (js/String.fromCharCode %))
                     (range (.charCodeAt "A" 0) (inc (.charCodeAt "Z" 0))))
        sym->field (zipmap symbols (map :value field-options))]
    (if-not template
      (throw (ex-info "Unknown expression string" {:expression expression}))
      (replace-symbols template sym->field))))
